export default {
    entityKey: 'code-pipelines',
    titles: {
        singular: 'Code Pipeline',
        plural: 'Code Pipelines'
    }
}
